<div>
    <svg *ngIf="loading"
        class="icon loading guide-loading">
        <use xlink:href="#icon-loading"></use>
    </svg>
    <ng-container *ngFor="let item of contentList">
        <!-- item.label 判断是否按钮 -->
        <button *ngIf="item.label && !item.configured; else text"
            nButton
            theme="text"
            [disabled]="item.permissionTips"
            [disabledTips]="item.permissionTips"
            [label]="item.label"
            (click)="configure(item)">
        </button>
        <ng-template #text>
            <span>{{ item.label || item }}</span>
        </ng-template>
    </ng-container>
    <ng-content *ngIf="!loading"></ng-content>
</div>